import React, { useState } from 'react';
import './newsletter.css';
import { Container, Row, Col } from 'reactstrap';
import maleTourist from '../assets/images/male-tourist.png';
import emailjs from 'emailjs-com';

const Newsletter = () => {
  const [useremail, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();

    emailjs.init("mRKco-Lkgq2hUda_Q");

    const templateParams = {
      useremail,
    };

    emailjs
      .send("service_temjk65", "template_58945jj", templateParams)
      .then(
        function (response) {
          console.log("Email sent successfully:", response);
          // Reset the form after successful email sending
          setEmail('');
          // You can add a success message or redirect the user here.
        },
        function (error) {
          console.log("Email sending failed:", error);
          // Handle the error or show an error message to the user.
        }
      );
  };

  return (
    <section className='newsletter'>
      <Container className="py-5">
        <Row>
          <Col lg='6'>
            <div className="newsletter__content">
              <h2>Subscribe now to get useful traveling information.</h2>

              <div className="newsletter__input">
                <input
                  type="email"
                  placeholder='Enter your email'
                  value={useremail}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button className="btn newsletter__btn" onClick={handleSubscribe}>
                  Subscribe
                </button>
              </div>

              <p>Discover the wonders of our planet, one destination at a time, with our latest travel newsletter. Unveil breathtaking landscapes, vibrant cultures, and extraordinary experiences as we bring the world to your inbox.</p>
            </div>
          </Col>
          <Col lg='6'>
            <div className="newsletter__img">
              <img src={maleTourist} alt="" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Newsletter;
